import { render, staticRenderFns } from "./UnloadingDetails.vue?vue&type=template&id=6797b47e&scoped=true"
import script from "./UnloadingDetails.vue?vue&type=script&lang=js"
export * from "./UnloadingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797b47e",
  null
  
)

export default component.exports